import { faCheck } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components";

interface QuestionnaireOptionProps {
	option: string;
	handleSelect: () => void;
	selected: boolean;
}

export default function QuestionnaireOption({
	option,
	handleSelect,
	selected,
}: QuestionnaireOptionProps) {
	return (
		<button
			className="flex w-full items-center gap-3 cursor-pointer rounded-xl p-3 bg-white border border-primary-gray-lightest"
			type="button"
			onClick={handleSelect}
		>
			{selected ? (
				<span className="w-5 h-5 min-w-5 rounded-full flex items-center justify-center bg-primary-blue">
					<Icon className="text-white w-[14px] h-[14px]" icon={faCheck} />
				</span>
			) : (
				<p className="w-5 h-5 min-w-5 rounded-full bg-white border-[1px] border-grey-soft"></p>
			)}
			<span className="text-[14px] font-semibold text-primary-blue-dark">{option}</span>
		</button>
	);
}
